module.exports = "<ul ng-if=\"$ctrl.itemCtrl.toggled\" class=\"submenu animated-ng-if\" ng-transclude>\n\n</ul>\n"